import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { ClockClockwise } from "@phosphor-icons/react";

export default function Activity() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/activity-log").then((r) => setItems(r.data)); }, []);

  const filtered = items.filter((i) =>
    !q || (i.action || "").toLowerCase().includes(q.toLowerCase()) || (i.user_email || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="p-6 md:p-10 space-y-6" data-testid="activity-page">
      <header>
        <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Audit</div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tight mt-1">Activity Log</h1>
        <p className="text-muted-foreground text-sm mt-1">Every user, every action — visible.</p>
      </header>

      <Input className="max-w-md bg-card border-border" placeholder="Filter by action or user..." value={q} onChange={(e) => setQ(e.target.value)} />

      <div className="rounded-lg border border-border overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-secondary/40 hover:bg-secondary/40">
              <TableHead>When</TableHead>
              <TableHead>User</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.length === 0 ? (
              <TableRow><TableCell colSpan={4} className="text-center py-10 text-muted-foreground">No activity yet.</TableCell></TableRow>
            ) : (
              filtered.map((a) => (
                <TableRow key={a.id}>
                  <TableCell className="text-xs text-muted-foreground font-mono whitespace-nowrap">{new Date(a.at).toLocaleString("en-IN")}</TableCell>
                  <TableCell className="text-sm">{a.user_email || "—"}</TableCell>
                  <TableCell>
                    <span className="text-xs uppercase tracking-wider px-2 py-1 rounded-md bg-secondary border border-border text-gold">
                      <ClockClockwise size={10} className="inline mr-1" /> {a.action}
                    </span>
                  </TableCell>
                  <TableCell className="text-xs text-muted-foreground font-mono">{JSON.stringify(a.meta || {})}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
